import React from "react";
import Icon from "@ant-design/icons";

export const EditIcon = (props) => {
   return (
      <Icon
         component={() => (
            <svg
               width="21"
               height="20"
               viewBox="0 0 21 20"
               fill="none"
               xmlns="http://www.w3.org/2000/svg"
            >
               <path
                  d="M7.38414 17.5324L0.955566 19.3324L2.75557 12.9039L14.527 1.18959C14.66 1.05352 14.819 0.945408 14.9943 0.871598C15.1697 0.797787 15.3581 0.759766 15.5484 0.759766C15.7387 0.759766 15.9271 0.797787 16.1026 0.871598C16.2779 0.945408 16.4369 1.05352 16.5699 1.18959L19.0984 3.73244C19.2323 3.86524 19.3386 4.02326 19.4111 4.19733C19.4837 4.37141 19.521 4.55814 19.521 4.74673C19.521 4.93531 19.4837 5.12204 19.4111 5.29613C19.3386 5.47021 19.2323 5.62821 19.0984 5.76101L7.38414 17.5324Z"
                  stroke="#252938"
                  stroke-width="1.25"
                  stroke-linecap="round"
                  stroke-linejoin="round"
               />
            </svg>
         )}
         {...props}
      ></Icon>
   );
};
